import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Checkout } from '@df/checkout/checkout.interfaces';
import { IfKlarnaPaymentDirective } from '@df/module-klarna/if-klarna-payment.directive';
import { CreditCard } from '@df/session/api/credit-cards/credit-card';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { SagepayPiSavedCardStatusComponent } from '../module/sagepay/pi/sagepay-pi-saved-card-status.component';
import { SagepayPiServiceDecorator } from '../module/sagepay/pi/sagepay.service.decorator';
import { Sagepay } from '../module/sagepay/sagepay.namespace';
import { CheckoutFormComponent } from './checkout-form.component';

@Component({
    selector: 'checkout-payment-status',
    templateUrl: './checkout-payment-status.html',
    standalone: true,
    imports: [CommonModule, IfKlarnaPaymentDirective, SagepayPiSavedCardStatusComponent, SizeClassDirective]
})
export class CheckoutPaymentStatusComponent {
    constructor(
        protected checkoutFormComponent: CheckoutFormComponent,
        protected sagepayPiService: SagepayPiServiceDecorator
    ) {}

    get paymentMethod(): Checkout.IPaymentMethod | undefined {
        return this.checkoutFormComponent.paymentMethod;
    }

    get card(): CreditCard | undefined {
        return this.checkoutFormComponent.paymentCard;
    }

    get isCardPayment(): boolean {
        return !!(this.card || this.paymentMethod?.code === Sagepay.Methods.PiForm);
    }

    get sagepayCardType(): string {
        return this.card?.type || this.sagepayPiService.selectedCardType?.toLowerCase() || '';
    }

    get title(): string {
        if (this.isCardPayment) {
            return this.cardTitle;
        }
        return this.paymentMethod?.title || '';
    }

    get cardTitle() {
        return this.sagepayPiService.getCardTitle(this.sagepayCardType);
    }
}
